import { PropertiesPanelControl, PropertiesPanelLabel, PropertiesPanelProperty } from './propertiesPanelProperty';
import React from 'react';
import { Checkbox } from '../checkbox';

export type PropertiesPanelCheckboxPropertyProps = {
    id: string;
    label: React.ReactNode;
    checked: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
};
export const PropertiesPanelCheckboxProperty: React.FC<PropertiesPanelCheckboxPropertyProps> = ({ id, label, checked, onChange, disabled }) => {
    return (
        <Checkbox
            disabled={disabled}
            checked={checked}
            label={label}
            onChange={(checked) => {
                onChange?.(checked);
            }}
        />
    );
};
